/* Quote funnel: no field values, consent-aware, native form delivery unchanged. */
(function () {
  'use strict';
  if (window.imdQuoteMeasurementBound) return;
  window.imdQuoteMeasurementBound = true;
  var config = document.querySelector('[data-imd-measurement-context]');
  var family = config ? config.dataset.productFamily : 'unspecified';
  var path = location.pathname;
  var locationGroup = path === '/' ? 'homepage' : /\/products\//.test(path) ? 'product' : /stainless-steel-panel-pcs-monitors/.test(path) ? 'stainless' : /\/pages\/contact\/?$/.test(path) ? 'contact' : 'other_page';
  var ttl = 30 * 60 * 1000;
  var privacyRequested = false;
  var entryContext = 'direct_or_other';
  try {
    var entryParams = new URLSearchParams(location.search);
    var entrySlug = entryParams.get('from') || '';
    if (locationGroup === 'contact' && entrySlug.length <= 200 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(entrySlug)) {
      if (entryParams.get('ref') === 'article-hardware') entryContext = 'article_hardware';
      else if (entryParams.get('ref') === 'product-help') entryContext = 'product_help';
    }
  } catch (_) { /* Entry classification must never affect delivery. */ }
  function allowed() {
    var s = window.screen || {};
    if (navigator.webdriver || s.width === s.height || (s.width === 1280 && s.height === 1200) || (s.width === 800 && s.height === 600)) return false;
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed()); }
    catch (_) { return false; }
  }
  function privacyReady() { document.dispatchEvent(new CustomEvent('imd:quote-privacy-ready')); }
  function loadPrivacy() {
    var shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) { privacyReady(); return; }
    if (privacyRequested || !shopify || typeof shopify.loadFeatures !== 'function') return;
    privacyRequested = true;
    try {
      // Consent-change events do not signal that the API has finished loading.
      // Request the API ourselves; tracking must not depend on the reviews badge.
      shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function (error) {
        if (!error) privacyReady();
      });
    } catch (_) { /* Missing privacy permission never blocks the customer's form. */ }
  }
  function send(name, id, extra) {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    try {
      window.gtag('event', name, Object.assign({form_id:id, form_location:locationGroup, product_family:family, page_path:path, entry_context:entryContext, transport_type:'beacon'}, extra || {}));
      return true;
    } catch (_) { return false; }
  }
  function read(key) { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } }
  function store(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } }
  function remove(key) { try { sessionStorage.removeItem(key); } catch (_) {} }
  function bind(form) {
    if (form.dataset.imdMeasurementBound) return;
    form.dataset.imdMeasurementBound = 'true';
    var id = form.dataset.imdQuoteForm;
    var key = 'imd_quote_pending_v1:' + id + ':' + path;
    var viewed = false, started = false, errors = {}, attempted = false;
    function view() { if (document.visibilityState !== 'hidden' && !viewed && send('quote_form_view', id)) viewed = true; }
    function start() { view(); if (!started && send('quote_form_start', id)) started = true; }
    function confirmed() {
      if (!form.querySelector('[data-imd-quote-result="success"]') || !allowed()) return;
      var pending = read(key);
      if (!pending || !pending.reference || Date.now() - pending.time > ttl || Date.now() < pending.time) { remove(key); return; }
      // Remove before sending so refresh/back/re-initialization cannot count it again.
      remove(key);
      send('generate_lead', id, {lead_reference:pending.reference, entry_context:['article_hardware', 'product_help'].indexOf(pending.entryContext) >= 0 ? pending.entryContext : 'direct_or_other'});
    }
    form.addEventListener('input', function (event) {
      if (event.target.matches('input:not([type="hidden"]),textarea,select')) start();
    });
    form.addEventListener('change', function () { start(); });
    form.addEventListener('invalid', function (event) {
      if (!allowed()) return;
      start();
      var validity = event.target.validity || {};
      var type = validity.valueMissing ? 'required_field' : validity.typeMismatch ? 'invalid_type' : 'invalid_value';
      if (!errors[type] && send('quote_form_error', id, {error_type:type})) errors[type] = true;
    }, true);
    function attempt() {
      // A submit event follows native validation; never preventDefault or submit ourselves.
      if (attempted || !allowed()) return;
      start();attempted = true;
      var reference = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
      var pending = {reference:reference, time:Date.now(), entryContext:entryContext};
      store(key, pending);
      var input = form.querySelector('[name="contact[Enquiry reference]"]');
      if (!input) { input = document.createElement('input');input.type = 'hidden';input.name = 'contact[Enquiry reference]';form.appendChild(input); }
      input.value = reference;
      send('quote_form_submit', id, {lead_reference:reference});
      // Allow a genuine retry if another native handler cancelled the navigation.
      window.setTimeout(function () { attempted = false;errors = {}; }, 5000);
    }
    form.addEventListener('submit', attempt);
    form.addEventListener('imd:quote-submit', attempt);
    function result() {
      if (!form.isConnected) return;
      confirmed();
      if (form.querySelector('[data-imd-quote-result="error"]') && !errors.server && send('quote_form_error', id, {error_type:'server'})) errors.server = true;
    }
    result();
    form.addEventListener('imd:quote-result', result);
    function refreshAfterPrivacy() {
      if (!form.isConnected) return;
      result();
      var rect = form.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && !form.querySelector('[data-imd-quote-result="success"]')) view();
    }
    document.addEventListener('visitorConsentCollected', refreshAfterPrivacy);
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', refreshAfterPrivacy);
    document.addEventListener('imd:quote-privacy-ready', refreshAfterPrivacy);
    document.addEventListener('visibilitychange', refreshAfterPrivacy);
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; }) && !form.querySelector('[data-imd-quote-result="success"]')) view();
      }, {threshold:0});
      observer.observe(form);
    }
  }
  document.querySelectorAll('form[data-imd-quote-form]').forEach(bind);
  document.addEventListener('imd:quote-form-ready', function (event) {
    if (event.target.matches && event.target.matches('form[data-imd-quote-form]')) bind(event.target);
  });
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('form[data-imd-quote-form]').forEach(bind); });
  loadPrivacy();
  if (document.readyState !== 'complete') window.addEventListener('load', loadPrivacy, {once:true});
})();
